module.exports = __webpack_public_path__ + "img/cotizaciones.72086a22.jpeg";